module.exports = __webpack_public_path__ + "1_0_65/img/app-store-badge.383648d3.svg";